module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/TV#1-110fa110d1a9255c469b7d1497e765bb91aaad5fa5c5ef7955c286e93c5fcd2c.svg";